<template>
  <div class="container">
    <div class="content">
      <h2>🐾 Paws for a Moment & Join StingyCat's Investment Party! 🐾 </h2>
      <p> Hello, wise whiskered investor! Before we unravel the world of wealth together, let's understand what makes your financial heart tick. We promise, in return, to offer a tail-tailored experience that is s purrfect for you. Select all that apply:</p>

      <div class="option" @click="toggleOption('gics')" :class="{ selected: isSelected('gics') }">
        <span class="icon">💰 </span>
        <b>HISAs:Invested here?</b> By sharing, StingyCat can whisk you away to the world of stable returns and security, ensuring your savings never face a cat-astrophe!
      </div>

      <div class="option" @click="toggleOption('stocks')" :class="{ selected: isSelected('stocks') }">
        <span class="icon">📈</span>
        <b>Stocks/ETFs: Dabble in these?</b> Let us know, and watch as we pounce on opportunities, giving you the tools to make purrfect picks in the ever-changing stock market jungle.
      </div>

      <div class="option" @click="toggleOption('options')" :class="{ selected: isSelected('options') }">
        <span class="icon">🚀</span>
        <b>Options: Treading these terrains?</b> What a great way to utilize strategies and leverage in a risk-adjusted way.  Options can be the best thing that's ever happened to us and the worst depending upon how we play.  This probably reminds you of working from home with a cat on your lap!
      </div>

      <div class="option" @click="toggleOption('futures')" :class="{ selected: isSelected('futures') }">
        <span class="icon">🧮 </span>
        <b>Futures: Way to hedge your bets! </b> Where hedging truly began.  From gold, oil, FX and commodities...are you a hedger or a speculator taking advantage of the signficant leverage it affords?  🐱 Think being a kitten but acting like a lion! 🦁
      </div>

      <div class="option" @click="toggleOption('halal')" :class="{ selected: isSelected('halal') }">
        <span class="icon">🕋</span>
        <b> Halal options only:</b> You are looking to avoid interest at all costs, calculate your obligatory zakat dues and keep on the straight path when it comes to your financial life.
      </div>

      <div class="option" @click="toggleOption('scared')" :class="{ selected: isSelected('scared') }">
        <span class="icon">🙀</span>
        <b>Got scratched once and never again or just never bothered out of fear</b> Investing scares you and you choose not to dabble in any of these trades.  
      </div>

      <div class="option" @click="toggleOption('none')" :class="{ selected: isSelected('none') }">
        <span class="icon">😔</span>
        <b>Never got a chance as I'm at a place with no money to invest right now</b> You are hoping to invest in the future once RiskyPaws helps me understand this financial world!  
      </div>

  
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary

export default {
  setup() {
    const store = onboardingStore();

    // Method to toggle investment option selection
    const toggleOption = (option) => {
      const index = store.formData.investment.indexOf(option);
      if (index === -1) {
        store.updateFormData({ investment: [...store.formData.investment, option] });
      } else {
        const updatedInvestments = store.formData.investment.filter(item => item !== option);
        store.updateFormData({ investment: updatedInvestments });
      }
      // After updating investment choices, also update the cat_whisperer
      updateCatWhisperer(store.formData.investment);
    };

    // Method to determine and set the cat_whisperer based on investment choices
    const updateCatWhisperer = (investments) => {
      let catWhisperer = ''; // Default to empty string if no match

      // Priority given to options and futures
      if (investments.includes('halal')) {
    catWhisperer = 'Muezza';
  } else if (investments.includes('options')) {
    catWhisperer = 'QuantCat';
  } else if (investments.includes('futures')) {
    catWhisperer = 'PokerPaws';
  } else if (investments.includes('gics')) {
    catWhisperer = 'StingyCat';
  } else if (investments.includes('stocks') || investments.includes('etfs')) {
    catWhisperer = 'MacroMeow';
  } else if (investments.includes('scared') || investments.includes('none')) {
    catWhisperer = 'Warm N. Fluffy';
  }

  store.updateFormData({ cat_whisperer: catWhisperer });
};

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.investment.includes(option);

    return { store, toggleOption, isSelected };
  },
};
</script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>